<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">卫生标准<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>所属门店</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>打卡类型</label>
              <el-select v-model="type" placeholder="Select" class="select-item">
                <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <!--              <label>商品名称</label>-->
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" width="7em"/>
              <el-checkbox v-model="limitState" style="margin-left: 8px;"><span style="white-space: nowrap; flex-shrink: 0">有限制</span></el-checkbox>
            </div>
            <div class="content-input-item">
              <label>启用状态</label>
              <el-select v-model="state" placeholder="Select" class="select-item">
                <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="editStandardDialog(-1)" size="default">添加</el-button>
            <el-button type="warning" @click="reuseStandard" size="default">一键复用</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
            <el-table-column property="shopName" label="所属门店" v-if="checkColList.indexOf('所属门店') > -1"/>
            <el-table-column property="brandName" label="卫生打卡类型" v-if="checkColList.indexOf('卫生打卡类型') > -1">
              <template #default="scope">
                {{scope.row.type == 1?'每日卫生打卡':scope.row.type == 2?'每周卫生打卡':scope.row.type == 3?'每月卫生打卡':'' }}
              </template>
            </el-table-column>
            <el-table-column property="area" label="区域" v-if="checkColList.indexOf('区域') > -1"/>
            <el-table-column property="location" label="位置" v-if="checkColList.indexOf('位置') > -1"/>
            <el-table-column property="" label="示例图" v-if="checkColList.indexOf('示例图') > -1">
              <template #default="scope">
                <div v-if="scope.row.standardImgList.length > 0" class="cursor" @click="userImgList(scope.row)">
                  <el-image class="item-img" fit="cover" :src="scope.row.standardImgList[0].smallImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
                <div v-else>
                  <el-image class="item-img" fit="cover"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
              <template #default="scope">
                <p :style="{color: scope.row.state == 2?'red':''}">{{scope.row.state == 0?'待启用':scope.row.state == 1?'已启用':scope.row.state == 2?'已停用':'' }}</p>
              </template>
            </el-table-column>
            <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1" sortable='custom'/>
            <el-table-column property="description" label="打卡说明" v-if="checkColList.indexOf('打卡说明') > -1" width="260"/>
            <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1">
              <template #default="scope">
                <el-space wrap>
                  <el-button @click="editStandardDialog(scope.$index,scope.row)" size="small" type="primary">编辑</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 1" @click="updateState(scope.row, 2)" size="small" type="warning" v-loading="scope.row.updateLoading">停用</el-button>
                  <el-button v-if="scope.row.state == 0 || scope.row.state == 2" @click="updateState(scope.row, 1)" size="small" type="success" v-loading="scope.row.updateLoading">开启</el-button>
                  <el-button @click="delStandard(scope.row, scope.$index)" size="small" type="danger" v-loading="scope.row.delLoading">删除</el-button>
                </el-space>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getStandardPageList, updateStandardState, delStandard} from "@/api/url";
import StandardDialog from "./components/standardDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import Drawer from "@/assets/js/drawer";
import UserImgList from "@/components/imgList/UserImgList";
import unLock from "@/layout/components/unLock";
import reuseStandardDialog from "@/views/hygiene/components/reuseStandardDialog";

export default {
  name: "HygieneStandard",
  components: { BtnGroup, SearchComponents, unLock, },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,
      delLoading: false,

      supplierIdArray: [],
      supplierId: 0,

      brandIdArray: [],
      brandId: 0,

      limitState: false,

      shopIdArray: [
        {name: '不限', id: 0},
      ],
      shopIdArr:[],
      shopId: 0,

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      typeArray: [
        {label: '不限', value: -1},
        {label: '每日卫生打卡', value: 1},
        {label: '每周卫生打卡', value: 2},
        {label: '每月卫生打卡', value: 3}
      ],
      type: -1,

      //刷新组
      colList: ['创建时间', '所属门店', '卫生打卡类型', '区域', '位置', '示例图','状态', '排序', '打卡说明', '操作'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '区域', value : 1},
        {label : '位置', value : 2},
      ],
      searchType: 1,
      searchValue: '',

      commodityTypeId: 0,
      commoditySubTypeId: 0,
      reSet: false

    }
  },
  methods: {

    getCommodityType(e) {
      console.log(e)
      this.commodityTypeId = e[0]
      this.commoditySubTypeId = e[1]
      this.reSet = e[2]
    },

    // 重置参数
    refreshParam() {
      // this.isChecked = true;
      this.state = -1;
      this.type = -1;
      this.limitState = false;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      } else if(column.prop == 'orderNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      }
      this.getPage();
    },


    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['type'] = this.type;
      param['state'] = this.state;
      param['sort'] = this.sort;
      param['limitState'] = this.limitState?1:0;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getStandardPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },

    editStandardDialog(idx, row) {
      let _title = '';
      let standardForm = {}
      if (idx > -1) {
        _title = '编辑卫生标准'
        standardForm = Object.assign({}, row);
        // console.log(standardForm)
      }else {
        _title = '添加卫生标准'
        // console.log(standardForm)
      }
      Dialog.open({
        title: _title,
        component: StandardDialog,
        data: {
          standardForm: standardForm,
          ids: idx,
          width: '670px',
        },
        // confirm: (result) => {
        //   this.getPage()
        // },
        close: () => {
          this.getPage()
        }
      })
    },



    updateState(row, state) {
      this.$confirm('确认' + (state == 1?'开启【':'停用【') + row.shopName + '】的【' + row.area + '（' + row.location + '）】卫生标准吗？').then(() => {
        row.updateLoading = true;
        let param = {};
        param['id'] = row.id;
        // param['state'] = state;
        postFormData(updateStandardState, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            row.state = state
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false;
        }).catch(()=> {
          row.updateLoading = false;
        })
      })
    },

    delStandard(row, idx) {
      this.$confirm('确认删除【' + row.shopName + '】的【' + row.area + '（' + row.location + '）】卫生标准吗？').then(() => {
        row.delLoading = true;
        let param = {};
        param['id'] = row.id;
        // param['state'] = state;
        postFormData(delStandard, param).then((data)=>{
          let {code, msg} = data;
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.delLoading = false;
        }).catch(()=> {
          row.delLoading = false;
        })
      })
    },

    userImgList(row) {
      let _title = '';
      _title = '图片列表'
      Drawer.open({
        title: _title,
        component: UserImgList,
        data: {
          imgArray: row.standardImgList,
          id: row.id,
          width: 908,
          from: 6
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    reuseStandard() {
      let _title = '';
      _title = '复用配置'
      Dialog.open({
        title: _title,
        component: reuseStandardDialog,
        data: {
          width: '1000px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    let ownShopList = JSON.parse(sessionStorage.getItem('ownShopList'))
    this.shopIdArray = this.shopIdArray.concat(ownShopList)
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
.item-img {
  width: 80px;
  height: 80px;
}
</style>
